/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: heyouqin@moyi365.com
 * @Date: 2024-01-30 16:26:24
 * @LastEditTime: 2024-01-30 16:27:17
 * @Descripttion: file content
 */
export default function remove2Body(id: string) {
	const oldElement = document.getElementById(id)
	oldElement && oldElement.remove()
}
